import { RequestCreatedByType, RequestHistoryAction, RequestHistoryStatus } from '@shared-features/enums/shipments.enum';
import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';
import { User } from '../../users/models/user.model';

export class RequestLog extends Model {
  @Expose() action: RequestHistoryAction;
  @Expose() createdAt: Date;
  @Expose() createdBy: User;
  @Expose() creatorType: RequestCreatedByType;
  @Expose() toType: RequestCreatedByType;
  @Expose() requestBody: string;
  @Expose() requestUrl: string;
  @Expose() responseData: string;
  @Expose() status: RequestHistoryStatus;
}
